import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // localStorage
import userReducer from '../redux/userSlice';
import loaderReducer from '../redux/loaderSlice';

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['user'], // only persist user, not loader
};

const rootReducer = combineReducers({
  user: userReducer,
  loader: loaderReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export const persistor = persistStore(store);
